import { InputAdornment, makeStyles } from '@material-ui/core'
import { useFormikContext } from 'formik'
import PropTypes from 'prop-types'
import React, { useEffect, useState } from 'react'

import {
  Form,
  FormikImageFileField,
  FormikSelect,
  FormikTextField,
  FormikToggle,
  mapToOptions,
} from 'src/modules/ui'

const useStyles = makeStyles(theme => ({
  select: {
    minWidth: 210,
  },
}))

const Basic = ({ categoryOptions }) => {
  return (
    <Form>
      <FormikImageFileField
        name="photo"
        margin="normal"
        label="Product Photo"
      />
      <FormikTextField
        name="name"
        margin="normal"
        label="Product Name"
        fullWidth
      />
      <Form.InputRow>
        <CategorySelector categoryOptions={categoryOptions} />
      </Form.InputRow>
      <Form.InputRow>
        <FormikTextField margin="normal" name="code" label="Product Code" />
        <FormikTextField margin="normal" name="unit" label="Unit" />
        <FormikToggle margin="normal" name="available" label="Available" />
      </Form.InputRow>
      <Form.InputRow>
        <PriceInputs />
      </Form.InputRow>
      <FormikTextField
        name="description"
        label="Description"
        margin="normal"
        fullWidth
        multiline
      />
    </Form>
  )
}

const PriceInputs = () => {
  const classes = useStyles()
  const { values } = useFormikContext()
  const { variablePrice, variablePriceUnit } = values

  return (
    <>
      <FormikToggle
        margin="normal"
        name="variablePrice"
        label="Variable Price"
      />
      <React.Fragment key={`${variablePriceUnit}_${variablePrice}`}>
        {variablePrice && (
          <FormikSelect
            className={classes.select}
            margin="normal"
            name="variablePriceUnit"
            label="Pricing Unit"
            options={[{ value: 'kg', label: 'kg' }]}
          />
        )}
        <FormikTextField
          label={variablePrice ? `Price per ${variablePriceUnit}` : 'Price'}
          name="price"
          margin="normal"
          placeholder="0.00"
          InputProps={{
            startAdornment: <InputAdornment position="start">£</InputAdornment>,
            endAdornment: variablePrice && (
              <InputAdornment position="end">
                {`/${variablePriceUnit}`}
              </InputAdornment>
            ),
          }}
        />
        {variablePrice && (
          <FormikTextField
            label="Average Unit Size"
            name="avEquivalentUnitSize"
            margin="normal"
            placeholder="0"
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  {variablePriceUnit}
                </InputAdornment>
              ),
            }}
          />
        )}
      </React.Fragment>
      <FormikTextField
        label="VAT"
        name="vatRate"
        margin="normal"
        placeholder="0.00"
        InputProps={{
          endAdornment: <InputAdornment position="end">%</InputAdornment>,
        }}
      />
    </>
  )
}

const CategorySelector = ({ categoryOptions }) => {
  const classes = useStyles()
  const { setFieldValue, setFieldTouched, values } = useFormikContext()
  const [categoryId, setCategoryId] = useState(values.categoryId)

  const mainCategoryOptions = categoryOptions.map(mapToOptions)
  const subcategoryOptions = values.categoryId
    ? categoryOptions
        .find(c => c.id === Number(values.categoryId))
        .subcategories.map(mapToOptions)
    : null

  useEffect(() => {
    if (values.categoryId !== categoryId) {
      setCategoryId(values.categoryId)
      setFieldValue('subcategoryId', '')
      setFieldTouched('subcategoryId', '')
    }
  }, [values.categoryId])

  return (
    <>
      <FormikSelect
        className={classes.select}
        margin="normal"
        name="categoryId"
        label="Product Category"
        options={mainCategoryOptions}
      />
      {subcategoryOptions && (
        <FormikSelect
          className={classes.select}
          margin="normal"
          name="subcategoryId"
          label="Subcategory"
          options={subcategoryOptions}
        />
      )}
    </>
  )
}

Basic.propTypes = {
  categoryOptions: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
      subcategories: PropTypes.arrayOf(
        PropTypes.shape({
          id: PropTypes.number,
          name: PropTypes.string,
          category: PropTypes.id,
        })
      ),
    })
  ),
}

export default Basic
